"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 业务系统配置模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/sysUser/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      url: '/protected/sysUser/query/' + id,
      method: 'get'
    });
  },
  saveItem: function saveItem(data) {
    return (0, _request.default)({
      url: '/protected/sysUser/save',
      method: 'post',
      data: data
    });
  },
  deleteItem: function deleteItem(data) {
    return (0, _request.default)({
      url: '/protected/sysUser/delete',
      method: 'post',
      data: data
    });
  },
  enableItem: function enableItem(id) {
    return (0, _request.default)({
      url: '/protected/sysUser/enable/' + id,
      method: 'get'
    });
  },
  disabledItem: function disabledItem(id) {
    return (0, _request.default)({
      url: '/protected/sysUser/disabled/' + id,
      method: 'get'
    });
  },
  passReset: function passReset(id) {
    return (0, _request.default)({
      url: '/protected/sysUser/passReset/' + id,
      method: 'get'
    });
  },
  passModify: function passModify(data) {
    return (0, _request.default)({
      url: '/protected/sysUser/passModify',
      method: 'post',
      data: data
    });
  },
  getUserWarehouseDetail: function getUserWarehouseDetail(id) {
    return (0, _request.default)({
      url: '/protected/user-warehouse/query/' + id,
      method: 'get'
    });
  },
  saveUserWarehouse: function saveUserWarehouse(data) {
    return (0, _request.default)({
      url: '/protected/user-warehouse/save-list',
      method: 'post',
      data: data
    });
  }
};